 import persistedReducer from "./reducers";
 import thunk from "redux-thunk";
 import {  compose } from "redux";
 import { persistStore } from "redux-persist";
 import { configureStore } from "@reduxjs/toolkit";


declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

export const store = configureStore({
  reducer: persistedReducer,
  middleware:[thunk]
});


export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;

